export default {"src":"/_next/static/media/cart.2a79b735.svg","height":10,"width":13,"blurWidth":0,"blurHeight":0};